import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { PervalValidators } from '../../../../shared';
import { Report } from '../../../models/report.model';
import { PSelectItem } from '../../../../shared/design-system/atoms/p-select/p-select-item.model';
import { EditorRoles } from '../../../models/editor-roles-http.dto';

@Component({
  selector: 'app-expert-immobilier-edit-mode',
  templateUrl: './expert-immobilier-edit-mode.component.html',
  styleUrls: ['./expert-immobilier-edit-mode.component.scss'],
})
export class ExpertImmobilierEditModeComponent implements OnChanges {
  @Input() expert!: Report.Expert;
  @Input() reportId!: string;
  @Input() exportPhoto!: string | undefined;
  @Input() roles?: EditorRoles;

  @Output() expertChanged = new EventEmitter<Report.Expert>();

  expertForm = new FormGroup({
    firstname: new FormControl(''),
    lastname: new FormControl(''),
    phone: new FormControl(''),
    email: new FormControl('', PervalValidators.email),
    experiences: new FormControl(''),
    role: new FormControl(''),
  });

  protected newExpert!: Report.Expert;

  roleItem!: PSelectItem;

  ngOnChanges(): void {
    this.newExpert = this.expert;
    this.newExpert.photo = this.exportPhoto;
    this.setFormValues();
  }

  lastnameChanged(event: Event) {
    this.newExpert = {
      ...this.newExpert,
      lastName: (event.target as HTMLInputElement).value,
    };

    this.expertChanged.emit(this.newExpert);
  }

  phoneChanged(event: Event) {
    this.newExpert = {
      ...this.newExpert,
      phone: (event.target as HTMLInputElement).value,
    };

    this.expertChanged.emit(this.newExpert);
  }

  firstnameChanged(event: Event) {
    this.newExpert = {
      ...this.newExpert,
      firstName: (event.target as HTMLInputElement).value,
    };

    this.expertChanged.emit(this.newExpert);
  }

  emailChanged(event: Event) {
    this.newExpert = {
      ...this.newExpert,
      email: (event.target as HTMLInputElement).value,
    };

    this.expertChanged.emit(this.newExpert);
  }

  experiencesChanged(event: Event) {
    this.newExpert = {
      ...this.newExpert,
      experiences: (event.target as HTMLInputElement).value,
    };

    this.expertChanged.emit(this.newExpert);
  }

  onCroppedImage(croppedImage: string | undefined): void {
    this.newExpert = {
      ...this.newExpert,
      photo: croppedImage,
    };

    this.expertChanged.emit(this.newExpert);
  }

  onClearImage(): void {
    this.newExpert.photo = undefined;
    this.expertChanged.emit(this.newExpert);
  }

  onRoleChange({ value }: PSelectItem): void {
    this.newExpert = {
      ...this.newExpert,
      role: value as string,
    };

    this.roleItem = { value };

    this.expertChanged.emit(this.newExpert);
  }

  private setFormValues(): void {
    this.expertForm.controls.lastname.setValue(this.expert.lastName);
    this.expertForm.controls.phone.setValue(this.expert.phone);
    this.expertForm.controls.firstname.setValue(this.expert.firstName);
    this.expertForm.controls.email.setValue(this.expert.email);
    this.expertForm.controls.experiences.setValue(this.expert.experiences);
    this.expertForm.controls.role.setValue(this.expert.role);
    this.roleItem = this.roles?.items
      .filter((editorRole) => editorRole.value === this.expert.role)
      .pop() as PSelectItem;
  }
}
